import { useState } from 'react'
import AgenzieService from '../services/AgenzieService/AgenzieService';
import UtilityService from '../services/UtillityServices/UtilityService';
import { alertService } from '../services/AlertService';
import { handleError } from '../model/handleError';

const useAgenzie = () => {
    const [loadingState, setLoadingState] = useState({
        isLoadingAgenzie: false,
        isLoadingAgenziaCreating: false,
        isLoadingAgenziaDelete: false,
        isLoadingAgenziaUpdate: false,
        isLoadingAgenzieByParams: false,
      });

      const [modalState, setModalState] = useState({
        showModalInfoAgenzia: false,
        showModalCreateAgenzia: false,
        showModalDeleteAgenzia: false,
        showModalUpdateAgenzia: false
      });
  
      const getAllAgenzie = async () => {
        setLoadingState({ ...loadingState, isLoadingAgenzie: true });
          try {
            let response = await AgenzieService.getAllAgenzie();
            if (response.ok) {
              const agenzie = await response.json();
              return agenzie;
            } 
          } catch (error) {
            alertService.error("Si è verificato un errore nel tentativo di visualizzare le agenzie", {autoClose: true});
          } finally {
            setLoadingState({ ...loadingState, isLoadingAgenzie: false });
          }
        };


        const getAgenzieByParams = async (params) => {
          setLoadingState({ ...loadingState, isLoadingAgenzieByParams: true });
          try {
            let obj;
            let response = await AgenzieService.getAgenzieByParams(params);
            const res = await response.json();
            const totalRecord = response.headers.get('X-Total-Record');
              obj = {
                data: res,
                count: totalRecord
              }
            return obj
          } catch (err) {
            handleError(err)
          } finally {
            setLoadingState({ ...loadingState, isLoadingAgenzieByParams: false });
          }
        }

        const createAgenzia = async (data) => {
          setLoadingState({ ...loadingState, isLoadingAgenziaCreating: true });
          try {
            let response = await AgenzieService.createAgenzia(data);
            alertService.success("Agenzia creata con successo", {autoClose: true});
            setModalState({...modalState, showModalCreateAgenzia: false });
            return response;
          } catch (error) {
            handleError(error)
          } finally {
            setLoadingState({ ...loadingState, isLoadingAgenziaCreating: false });
          }
          // setLoadingState({ ...loadingState, isLoadingAgenziaCreating: true });
          // let response = await AgenzieService.createAgenzia(data);
          // setLoadingState({ ...loadingState, isLoadingAgenziaCreating: false });
      
          // if (response.error) {
          //     let match = response.error.match(/Duplicate entry '(\d+)' for key 'piva'/);
          //     if (match) {
          //         const pivaDuplicata = match[1];
          //         const errorMsg = `Ragione sociale con partita IVA ${pivaDuplicata} già presente`;
          //         alertService.warn(errorMsg, {autoClose: true});
          //     } else {
          //       alertService.error("Si è verificato un errore", {autoClose: true});
          //     }
          //     return; 
          // } else {
          //     alertService.success("Agenzia creata con successo", {autoClose: true});
          //     setModalState({...modalState, showModalCreateAgenzia: false });
          //     return response;
          // }
      }

      const deleteAgenzia = async (id) => {
        try {
          setLoadingState({ ...loadingState, isLoadingAgenziaDelete: true });
            let response = await AgenzieService.deleteAgenzia(id);
            const res = await response.json();
            alertService.success("Agenzia eliminata con successo", {autoClose: true});
            setModalState({...modalState, showModalDeleteAgenzia: false });
            return res;
          } catch (error) {
            handleError(error)
          } finally {
            setLoadingState({ ...loadingState, isLoadingAgenziaDelete: false });
        }
      }

      const updateAgenzia = async (data) => {
        try {
          setLoadingState({ ...loadingState, isLoadingAgenziaUpdate: true });
            let response = await AgenzieService.updateAgenzia(data);
            alertService.success("Agenzia aggiornata con successo", {autoClose: true});
            setModalState({...modalState, showModalUpdateAgenzia: false });
            return response;
          } catch (error) {
            handleError(error)
          } finally {
            setLoadingState({ ...loadingState, isLoadingAgenziaUpdate: false });
        }
      }
      
  return {
    getAllAgenzie,
    createAgenzia,
    loadingStateAgenzie: loadingState,
    modalStateAgenzie: modalState,
    setModalStateAgenzie: setModalState,
    updateAgenzia,
    deleteAgenzia,
    getAgenzieByParams
  }
}

export default useAgenzie